// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../_utils/select-wrapper';
import { DeliveryOption, PrintFinish } from '../prop-types';
import {
  calculateSelectedFinish,
  availableFinishKeys,
  availableFinishOptions,
  finishValue,
} from '../common/finish-and-delivery-options';

const handleFinishChange = (
  deliveryOption,
  value,
  finishesByDeliveryOption,
  onChange
) => {
  onChange({
    finish: calculateSelectedFinish(
      deliveryOption.key,
      value,
      finishesByDeliveryOption
    ),
  });
};

const FinishSelector = ({
  deliveryOption,
  finishesByDeliveryOption,
  finishes,
  finish,
  onChange,
}) => {
  const finishKeys = availableFinishKeys(
    finishesByDeliveryOption,
    deliveryOption
  );

  return (
    <Select
      label="Paper Quality"
      aria-label="Select Finish"
      value={finishValue(finish, finishKeys)}
      options={availableFinishOptions(finishes, finishKeys)}
      inputStyleLink
      withCaret
      onChange={value =>
        handleFinishChange(
          deliveryOption,
          value,
          finishesByDeliveryOption,
          onChange
        )
      }
    />
  );
};

FinishSelector.propTypes = {
  deliveryOption: DeliveryOption,
  finishesByDeliveryOption: PropTypes.objectOf(PropTypes.arrayOf(PrintFinish)),
  finishes: PropTypes.arrayOf(PrintFinish),
  finish: PrintFinish,
  onChange: PropTypes.func,
}.isRequired;

export default FinishSelector;
